/**
 * House of Learning (HoL) overview — extracted from the HoL Catalogue (October 2022).
 * Injected into the bot's system prompt so it can answer questions about Metro's L&D structure.
 */
export const HOL_CONTEXT_MD = `
# House of Learning (HoL) – Überblick

## Mission & Vision
- **Mission:** "Growing our business by growing our people."
- **Vision:** Championing learning and development to reach €40 billion in sales by 2030.
- Gegründet 2004. Täglich engagieren sich mehr als 2.000 Kolleg:innen im Lernen.
- Lernplattform: **M|Power** (globale Learning Suite — alle Kurse und Programme sind dort zugänglich).

## Zwei Säulen des Portfolios

### Säule 1 – Learning Solutions (Funktionales Lernen)
Kurse und Lernpfade für ausgewählte Kernfunktionen und Schlüsselrollen:
- **Wholesale Functions:** Offer Management, Sales, Trader Franchise, Operations
- **Wholesale Enablers:** Finance, HR, Digital
- Diese Kurse sind für alle Mitarbeitenden in der jeweiligen Funktion zugänglich und self-paced in M|Power verfügbar.
- **Das sind die Kurse, die in dieser Coaching-Session für Daniel empfohlen werden.**

### Säule 2 – International Talent Development & Leadership Programs
Mehrmonatige Programme für ausgewählte High Potentials — man wird nominiert, nicht einfach angemeldet.
Die Programme ergänzen die funktionalen Kurse: Kurse bauen konkrete Skills auf (Säule 1), Programme beschleunigen den Karrieresprung (Säule 2).

**Übersicht der Programme:**
| Program | Zielgruppe | Dauer |
|---|---|---|
| **METRO Potentials Program** | Top Master-Absolventen, max. 2 Jahre Berufserfahrung | k.A. |
| **My(R)evolution** (Campus Düsseldorf) | High Potentials aller Funktionen, ~3–5 Jahre Erfahrung, Campus-Entitäten | k.A. |
| **Future Leaders Program** | High Potentials aller Funktionen (L3), ~5–8 Jahre Erfahrung | k.A. |
| **Women Leadership Program** | Top-Talente (L2/L3) in Commercial Functions | k.A. |
| **METRO Sustainable Leadership Program (MSLP)** | Erfahrene Führungskräfte (L3/Store Management) | k.A. |
| **Next Gen Offer** | Assistant/Junior Category Manager (L4), min. 2–3 Jahre Einkaufserfahrung | 10 Monate |
| **Master in Store Operations** | Store Manager (L3), min. 3 Jahre Operations-Erfahrung | 8 Monate |
| **Next Gen Finance** | Finance-Professionals (L3/L4), ~5–8 Jahre Erfahrung | 9 Monate |
| **Accelerate** | Mid-Level, Cross-functional, Country Board Potentials | k.A. |
| **Booster** | Country CEOs und globale Executives | k.A. |

**Für Daniel relevant:** **My(R)evolution** (Standort Düsseldorf, ~3–5 Jahre Erfahrung, alle Funktionen) — erreichbar nach dem Schritt zum Senior Account Manager.

## Nominierungsprozess (gilt für alle Programme)
Programme können nicht selbst gebucht werden. Der Weg zur Nominierung:
1. Mitarbeitender zeigt Interesse und äußert Motivation gegenüber **Line Manager und HR**
2. Hohe Performance-Potential-Bewertung im **M|Power Assessment** ist Voraussetzung
3. **100% Local Board Support** muss vorhanden sein
4. **Local Board + HR** sendet die Nominierung an House of Learning
5. Ein **Selection Committee** aus Business- und HR-Führungskräften bestätigt die Finalliste

Alle Programme erfordern außerdem: vertikale Bewegung realistisch innerhalb von 24 Monaten, Bereitschaft ~2h/Woche zusätzlich zu investieren, gute Englischkenntnisse.

**Wichtig:** Programme sind kein Bestandteil des Aktionsplans in dieser Coaching-Session — sie sind ein mittelfristiger Ausblick. Der konkrete Plan besteht aus Kursen (Säule 1), die Daniel jetzt angehen kann.

## Capability Building – 4-Schritte-Ansatz
1. **Consultancy** – Übersetzung der strategischen Ziele (SPP) in einen L&D-Fahrplan
2. **Assessment** – Messung der aktuellen Fähigkeiten via Capability Frameworks; Ergebnis: Individual Development Plan (IDP) — diese Coaching-Session entspricht diesem Schritt
3. **Implementation** – Umsetzung der Lernmaßnahmen (physisch, virtuell, hybrid)
4. **Steering** – Erfolgsmessung via KPI-Follow-up

## Strategischer Kontext
- Metro-Strategie: **"sCORE – Wholesale to the max"**
- Wachstum via: Food Service Distribution (FSD), digitaler Vertrieb, Franchise für kleinere Händler, Key-Account-Ausbau im Hospitality-Bereich
`;
